module.exports = __webpack_public_path__ + "static/mapa-1f4c71bc377c851a0944f122703f961f.png";